(() => {
  const selector = '[data-naxos-release-status]';
  const requests = new Map();

  function isValidReleaseDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  }

  function isFutureRelease(value, now = new Date()) {
    if (!isValidReleaseDate(value)) return false;
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    return value > today;
  }

  function label({ releaseDate, outOfStock, soldOutLabel } = {}) {
    if ((outOfStock === true || outOfStock === 'true') && isValidReleaseDate(releaseDate)) {
      return window.NaxosText(isFutureRelease(releaseDate)
        ? 'naxos_ui.not_yet_available'
        : 'naxos_ui.back_in_stock_soon');
    }
    return soldOutLabel || window.NaxosText('products.product.sold_out');
  }

  function refreshLabel(element) {
    const value = label(element.dataset);
    if (element.textContent !== value) element.textContent = value;
    if (element.dataset.buttonTitle) {
      element.closest('button')?.setAttribute('aria-label', `${value}: ${element.dataset.buttonTitle}`);
    }
  }

  function setLabel(element, data) {
    element.dataset.naxosReleaseStatus = '';
    element.dataset.releaseDate = data.releaseDate || '';
    element.dataset.outOfStock = String(data.outOfStock === true || data.outOfStock === 'true');
    element.dataset.soldOutLabel = data.soldOutLabel || window.NaxosText('products.product.sold_out');
    element.dataset.buttonTitle = data.buttonTitle || '';
    refreshLabel(element);
  }

  function clear(element) {
    element.removeAttribute('data-naxos-release-status');
  }

  function refresh(root = document) {
    if (root.matches?.(selector)) refreshLabel(root);
    root.querySelectorAll?.(selector).forEach(refreshLabel);
  }

  function load(productUrl, variantId) {
    const url = new URL(productUrl, window.location.origin);
    if (url.origin !== window.location.origin) return Promise.resolve(null);
    url.searchParams.set('section_id', 'naxos-product-availability');
    if (variantId) url.searchParams.set('variant', variantId);
    const key = url.href;
    if (!requests.has(key)) {
      requests.set(key, fetch(key, { credentials: 'same-origin' })
        .then(response => response.ok ? response.text() : '')
        .then(html => {
          const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
          return element ? { releaseDate: element.dataset.releaseDate, outOfStock: element.dataset.outOfStock === 'true' } : null;
        })
        .catch(() => null));
    }
    return requests.get(key);
  }

  window.NaxosReleaseStatus = { isFutureRelease, label, setLabel, clear, refresh, load };
  refresh();
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) refresh(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', () => refresh());
})();
